import { IGateItem, IParkingLotItem } from '@pkp-g/core';

export interface ICameraItem {
  id: string;
  parkingLotId: string;
  gateId: string;
  code: string;
  name: string;
  type: CameraTypeEnum;
  vendor: CameraVendorEnum;
  ipAddress: string;
  httpPort: number;
  rtspPort: number;
  username: string;
  minConfidence: number;
  recognitionRegion: string;
  direction: string;
  status: CameraStatusEnum;
  lastSeenAt: string;
  lastPlateAt: string;
  lastError: string;
  firmwareVersion: string;
  model: string;
  serialNumber: string;
  notes: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  latitude: number;
  longitude: number;
  parkingLot: IParkingLotItem;
  gate: IGateItem;
}

export interface ICameraPayload {
  parkingLotId: string;
  gateId: string;
  code: string;
  name: string;
  type: string;
  vendor: CameraVendorEnum;
  ipAddress: string;
  httpPort: number;
  rtspPort: number;
  username: string;
  password: string;
  minConfidence: number;
  recognitionRegion: string;
  direction: string;
  model: string;
  notes: string;
  isActive: boolean;
  latitude: number;
  longitude: number;
}

export interface ICameraParams {
  id?: string;
  parkingLotId?: string;
  gateId?: string;
  code?: string;
  ipAddress?: string;
  status?: string;
  type?: string;
  pageIndex?: number;
  pageSize?: number;
}

export enum CameraTypeEnum {
  Entry = 'Entry',
  Exit = 'Exit',
  Surveillance = 'Surveillance',
}

export const ICameraTypeLabel: Record<CameraTypeEnum, string> = {
  [CameraTypeEnum.Entry]: 'Вход',
  [CameraTypeEnum.Exit]: 'Выход',
  [CameraTypeEnum.Surveillance]: 'Обзорное',
};

export enum CameraStatusEnum {
  Online = 'Online',
  Offline = 'Offline',
  Error = 'Error',
}

export const ICameraStatusLabel: Record<CameraStatusEnum, string> = {
  [CameraStatusEnum.Online]: 'Онлайн',
  [CameraStatusEnum.Offline]: 'Оффлайн',
  [CameraStatusEnum.Error]: 'Тех работы',
};

export enum CameraDirectionEnum {
  Forward = 'Forward',
  Reverse = 'Reverse',
}

export const ICameraDirectionLabel: Record<CameraDirectionEnum, string> = {
  [CameraDirectionEnum.Forward]: 'Вперед',
  [CameraDirectionEnum.Reverse]: 'Обратное',
};

export enum CameraVendorEnum {
  Hikvision = 'Hikvision',
  Dahua = 'Dahua',
  Other = 'Other',
}

export const ICameraVendorLabel: Record<CameraVendorEnum, string> = {
  [CameraVendorEnum.Hikvision]: 'Hikvision',
  [CameraVendorEnum.Dahua]: 'Dahua',
  [CameraVendorEnum.Other]: 'Другое',
};
